import { MaskService } from 'react-native-masked-text';
import { differenceInYears, format, parse } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import parseISO from 'date-fns/parseISO';
import { months } from '~/consts/months';

export const validateDate = (date: string): boolean => {
  if (!date || (date && date.length !== 10)) {
    return false;
  }

  const valid = MaskService.isValid('datetime', date, {
    format: 'DD/MM/YYYY',
  });

  if (valid) {
    if (parse(date, 'dd/MM/yyyy', new Date()).getFullYear() >= 1900) {
      return true;
    }
    return false;
  }

  return false;
};

export const checkIfIsLegalAge = (birthday: string) => {
  if (birthday === '' || birthday?.length < 10) {
    return false;
  }

  const birtdayDate = parse(birthday, 'dd/MM/yyyy', new Date());
  const age = differenceInYears(new Date(), birtdayDate);

  return age >= 18;
};

export const formatBrDate = (date: string): string => {
  const [day, month, year] = date.split('/');

  return `${year}-${month}-${day}`;
};

export const dateToISO = (date: string): string | null => {
  if (!date || date.length !== 10) return null;

  const [day, month, year] = date.split('/');

  return new Date(`${year}-${month}-${day}`).toISOString();
};

export const isMaxAgeValid = (date: string, maxAge: number) => {
  const parsedDate = parse(String(date), 'dd/MM/yyyy', new Date());

  const age = differenceInYears(new Date(), parsedDate);

  return age <= maxAge;
};

export const isAgeIntervalValid = (
  date: string,
  minAge: number,
  maxAge: number
) => {
  const parsedDate = parse(String(date), 'dd/MM/yyyy', new Date());

  const age = differenceInYears(new Date(), parsedDate);

  return age >= minAge && age <= maxAge;
};

export const formatDate = (date: string) => {
  return format(parseISO(date), 'dd/MM/yyyy');
};

export const extensiveDate = (date: string) => {
  return format(parseISO(date), "dd/MM/yyyy 'às' HH:mm", { locale: ptBR });
};

export function parseDate(date: string) {
  if (!date) return '';
  const dateArray = date?.split('/');
  const month = dateArray[1] ? dateArray[1].padStart(2, '0') : 0;
  const day = dateArray[0] ? dateArray[0].padStart(2, '0') : 1;
  const year = Number(dateArray[2]);
  const parsedDate = `${year}-${month}-${day}`;
  return parsedDate;
}

export function formatDueDate(dueDate?: string, noYear?: boolean) {
  if (!dueDate) return 'Indefinido';

  const formattedDate = dueDate.split('-').reverse().join('/');

  if (noYear) return formattedDate.substring(0, formattedDate.length - 5);

  return formattedDate;
}

export function getMonthName(dueDate: string) {
  if (dueDate.includes('/')) {
    const dateArray = dueDate.split('/');

    if (dateArray[1])
      return months[parseInt(dateArray[1], 10) - 1]?.description;
  }

  const dateArray = dueDate.split('-');

  if (dateArray[1]) return months[parseInt(dateArray[1], 10) - 1]?.description;

  return 'Indefinido';
}
